import { Component,OnInit,} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Global } from "src/app/global";
import { ApiService } from "src/app/service/apiServices";
import { AuthService } from "src/app/service/auth/auth.service";

@Component({
  selector: "app-prescricao-v2",
  templateUrl: "./prescricao-v2.component.html",
  styleUrls: ["./prescricao-v2.component.css"],
})
export class PrescricaoV2Component implements OnInit {
 
  listaPrescricoes: any[] = []; 
  atendimentioId: number = null;
  presenca: any;

  constructor(
    public service: ApiService,
    private route: ActivatedRoute,
    private authService: AuthService,
    private global : Global
  ) {
  }

  ngOnInit() {
    this.atendimentioId = Number(this.route.snapshot.paramMap.get("uuid"));
    this.authService.currentPresenca.subscribe((res) => {
      if (res) {
        this.presenca = res;
      }
    });

    this.listarPrescricoesAtendimento();
    this.listaPrescricoes = this.listaPrescricoes.map((p) => ({
      ...p,
      exibirDetalhes: false,
    }));
  }

  toggleDetalhes(index: number) {
    this.listaPrescricoes[index].exibirDetalhes =
      !this.listaPrescricoes[index].exibirDetalhes;
  }

  listarPrescricoesAtendimento() {
    this.service
      .Get("PrescricaoUrgenciaV2?atendimentoId=" + this.atendimentioId)
      .then((result) => {
        this.listaPrescricoes = Array.isArray(result) ? result : [];
        if (this.listaPrescricoes.length > 0) {
          this.listaPrescricoes.forEach((item) => {
            item.data = new Date(item.data);
          });
        }
      });
  }
}
